import React, { useState, useEffect } from 'react';
import { Button, Switch, Form, Input, Typography } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ContentCustom, PageHeader } from '../../components';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';

export const MyAccountant = () => {
  const { dispatchAPI, user } = useAuthContext();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [accountantEmail, setAccountantEmail] = useState();
  const [consent, setConsent] = useState(false);
  const [modify, setModify] = useState();
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { message } = useErrorMessage();

  const { Title } = Typography;

  const getUser = async () => {
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/users/${user?._id}`
      });
      setAccountantEmail(data.accountant);
      if (data.accountant) {
        setModify(false);
      } else {
        setModify(true);
      }
      setConsent(data.consent);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  const updateUser = async (body) => {
    let data = body;
    if (!body.accountant) {
      data = { accountant: '', consent: false };
    }
    try {
      await dispatchAPI('PATCH', {
        url: `/users/${user?._id}`,
        body: { ...data, consent }
      });
      setForceRefresh(!forceRefresh);
      getUser();
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  useEffect(() => {
    (async () => {
      await getUser();
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <PageHeader title={t(`myAccountant.myAccountant`)} />
      <ContentCustom>
        {t(`myAccountant.service`)}
        <Form
          form={form}
          onFinish={updateUser}
          layout="vertical"
          wrapperCol={{ xs: { span: 24 }, md: { span: 12 } }}
        >
          <>
            {consent ? (
              <Form.Item
                rules={[
                  { required: true },
                  {
                    type: 'email'
                  }
                ]}
                name={['accountant']}
                label={t(`myAccountant.email`)}
              >
                {modify ? (
                  <Input allowClear />
                ) : (
                  <Title level={5}>{accountantEmail}</Title>
                )}
              </Form.Item>
            ) : (
              <Form.Item
                rules={[
                  {
                    type: 'email'
                  }
                ]}
                name={['accountant']}
                label={t(`myAccountant.email`)}
              >
                {modify ? (
                  <Input allowClear />
                ) : (
                  <Title level={5}>{accountantEmail}</Title>
                )}
              </Form.Item>
            )}
          </>
          <Form.Item name={['consent']} noStyle valuePropName="checked">
            <Switch
              checked={consent}
              style={{ margin: '0 16px 16px 0' }}
              onChange={() => setConsent(!consent)}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              disabled={!modify}
            />
            {t(`myAccountant.consent`)}
          </Form.Item>

          {modify ? (
            <Form.Item>
              <Button type="primary" htmlType="submit">
                {t(`buttons.save`)}
              </Button>
            </Form.Item>
          ) : (
            <Button
              type="secondary"
              htmlType="button"
              onClick={() => setModify(true)}
            >
              {t(`buttons.edit`)}
            </Button>
          )}
        </Form>
      </ContentCustom>
    </>
  );
};
